module.exports = __webpack_public_path__ + "static/media/icone_home.ee6dcb40.svg";